import React, { Children } from 'react';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import Toolbar from '@mui/material/Toolbar';
import Link from '@mui/material/Link';
import Tooltip from '@mui/material/Tooltip';

import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';
import SpeedIcon from '@mui/icons-material/Speed';
import Typography from '@mui/material/Typography';
import MonitorHeartOutlinedIcon from '@mui/icons-material/MonitorHeartOutlined';
import RestoreOutlinedIcon from '@mui/icons-material/RestoreOutlined';
import PersonIcon from '@mui/icons-material/Person';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import RefreshIcon from '@mui/icons-material/Refresh';
import LogoutIcon from '@mui/icons-material/Logout';
import MenuIcon from '@mui/icons-material/Menu';
import BarChartIcon from '@mui/icons-material/BarChart';
import PublicIcon from '@mui/icons-material/Public';
import VerticalSplitIcon from '@mui/icons-material/VerticalSplit';
import HomeIcon from "@mui/icons-material/Home";
import TopicIcon from '@mui/icons-material/Topic';
import StorageIcon from '@mui/icons-material/Storage';
import SaveAsIcon from '@mui/icons-material/SaveAs';
import DriveFileMoveIcon from '@mui/icons-material/DriveFileMove';

import MenuApp from '../MenuApp/MenuApp';
import DashBoard from '../../Pages/DashBoard/Dashboard';
import Monitor from '../../Pages/Monitor/Monitor';
import Zone from '../../Pages/Zone/Zone';
import Group from '../../Pages/Group/Group';
import Login from "../../Components/Login/Login";
import Help from "../../Pages/Help/Help"

import sharedService from "../../../Services/SharedService";
import { CUSTOM_SIDEBAR, DOMAIN } from './Utils/CustomSideBar';
import { CHECK_EMPTY_STRING } from '../../../Utils/string';
import { grey } from '@mui/material/colors';
import { format } from "date-fns";

import logo from "../../../Asset/logo.svg"
import authService from '../../../Services/AuthService';
import { goTo } from '../../../Utils/helper';
import User from '../../Pages/User/User';
import ChartComponent from '../../Pages/Chart/Chart';
import { Alert, Button } from '@mui/material';
import { BOXGROUP_ID, groupBR, ID_GROUPS, idGroupBR } from '../../../Utils/const';
import { NewExcel } from '../../../Utils/excel';
import { Menu, drawerWidth } from './Utils/CustomSideBar';
import { BOX_DOT2 } from './data';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import Audio from '../../Pages/Help/Components/AC/Audio';
import Map from '../../Pages/Map/Map';
import ParamsComponent from '../../Pages/Params';
import MonitorBR from '../../Pages/Monitor/Components/MonitorBR';
import DashBoardBR from '../../Pages/DashBoard/Components/DashboardBR';
import Exploit from '../../Pages/Exploit';

class App extends React.Component {
    constructor(props) {
        super(props)
        this.container = this.props.window !== undefined ? () => window().document.body : undefined;
        this.domain = window.location.pathname;
        this.now = format(Date.now(), "yyyy-MM-dd");

        this.state = {
            open: false,
            groups: [],
            group_id: "",
            time: {
                start: this.now,
                end: this.now
            },
            auth: false,
            mobileOpen: false,
            boxSelected: "",
            metricSelected: "",
            exportExcel: false,
            searchRecords: false,
            userName: authService?.getUserInfo()?.full_name || "",
            isOpenBR: false
        }
    }

    drawer(domain) {
        return (
            <div>
                <div className='p-14'>
                    <Grid container>
                        <Grid xs={3} item>
                            <img src={logo} alt="logo" />
                        </Grid>
                        <Grid xs={9} item className="pt-6 pl-10">
                            <Typography
                                sx={{
                                    fontWeight: 700,
                                    fontSize: 14
                                }}
                            >THUẬN PHONG</Typography>
                        </Grid>
                    </Grid>
                </div>
                <List sx={{ width: "100%", maxWidth: drawerWidth }} component="nav" className="left-menu">
                    {Children.toArray(Menu().map((text, index) => (
                        <>
                            <Link
                                href={(() => CUSTOM_SIDEBAR(index))()}
                                underline="none"
                                color={(() => {
                                    if (index === +0) {
                                        if ([CUSTOM_SIDEBAR(index), "/", "/app", "/app/"].includes(domain)) {
                                            return "#FBBC05";
                                        }
                                        return grey[50];
                                    } else {
                                        if (domain === CUSTOM_SIDEBAR(index)) {
                                            return "#FBBC05";
                                        }
                                        return grey[50];
                                    }
                                })()}
                                variant={(() => {
                                    if (index === +0) {
                                        if ([CUSTOM_SIDEBAR(index), "/", "/app", "/app/"].includes(domain)) {
                                            return "h6";
                                        }
                                        return "subtitle1";
                                    } else {
                                        if (domain === CUSTOM_SIDEBAR(index)) {
                                            return "h6";
                                        }
                                        return "subtitle1";
                                    }
                                })()}

                                className={index !== +2 ? "sidebar" : ""}
                            >
                                <ListItemButton
                                    // hidden={index === +2 ? true : false}
                                    key={text}
                                    className="pb-15"
                                    sx={{
                                        fontSize: 16
                                    }}
                                    onClick={() => index === +2 && this.handleSubMenu()}
                                >
                                    <ListItemIcon>
                                        {(() => {
                                            switch (index) {
                                                case +0:
                                                    return (
                                                        <SpeedIcon
                                                            className="fontsz-30"
                                                            style={{ color: [CUSTOM_SIDEBAR(index), "/", "/app", "/app/"].includes(domain) ? "#FBBC05" : grey[50] }}
                                                        />
                                                    )
                                                case +1:
                                                    return (
                                                        <>
                                                            {window.localStorage.getItem('group_id') === ID_GROUPS.DOT ?
                                                                <RestoreOutlinedIcon
                                                                    className="fontsz-30 mr-25"
                                                                    style={{ color: domain === '/app/monitor' ? "#FBBC05" : grey[50] }}
                                                                />
                                                                : idGroupBR.includes(window.localStorage.getItem('group_id')) ?
                                                                    <PublicIcon className="fontsz-27 mr-25"
                                                                        style={{ color: domain === '/app/map' ? "#FBBC05" : grey[50] }} />
                                                                    :
                                                                    <MonitorHeartOutlinedIcon
                                                                        className="fontsz-30 mr-25"
                                                                        style={{ color: domain === CUSTOM_SIDEBAR(index) ? "#FBBC05" : grey[50] }}
                                                                    />
                                                            }

                                                        </>
                                                    )
                                                case +2:
                                                    return (
                                                        <>
                                                            {idGroupBR.includes(window.localStorage.getItem('group_id')) ?
                                                                <MonitorHeartOutlinedIcon className="fontsz-27 mr-25"
                                                                    style={{ color: domain === '/app/monitor/list' ? "#FBBC05" : grey[50] }} />
                                                                :
                                                                [ID_GROUPS.KG, ID_GROUPS.AC].includes(window.localStorage.getItem('group_id')) ?
                                                                    <RestoreOutlinedIcon
                                                                        className="fontsz-30 mr-25"
                                                                        style={{ color: domain === '/app/monitor' ? "#FBBC05" : grey[50] }}
                                                                    />
                                                                    : window.localStorage.getItem('group_id') === ID_GROUPS.DOT ?
                                                                        <BarChartIcon
                                                                            className="fontsz-30"
                                                                            style={{ color: domain === CUSTOM_SIDEBAR(index) ? "#FBBC05" : grey[50] }}
                                                                        />
                                                                        :
                                                                        <>
                                                                            <RestoreOutlinedIcon
                                                                                className="fontsz-30 mr-25"
                                                                                style={{ color: [`${DOMAIN.MONITOR}/list`, `${DOMAIN.MONITOR}/report`].includes(domain) ? "#FBBC05" : grey[50] }}
                                                                            />
                                                                            <ListItemText
                                                                                primary={text}
                                                                                style={{ color: [`${DOMAIN.MONITOR}/list`, `${DOMAIN.MONITOR}/report`].includes(domain) ? "#FBBC05" : grey[50] }}
                                                                            />
                                                                            {!this.state.open ? <ExpandMore style={{ color: grey[50] }} className="fontsz-20 ml-40 mt-4" /> : <ExpandLess style={{ color: grey[50] }} className="fontsz-20 ml-40 mt-4" />}
                                                                        </>
                                                            }

                                                        </>
                                                    )
                                                case +3:
                                                    return <>
                                                        {window.localStorage.getItem('group_id') === ID_GROUPS.KG ?
                                                            <BarChartIcon
                                                                className="fontsz-30"
                                                                style={{ color: domain === CUSTOM_SIDEBAR(index) ? "#FBBC05" : grey[50] }}
                                                            />
                                                            :
                                                            window.localStorage.getItem('group_id') === ID_GROUPS.DOT ?
                                                                <MonitorHeartOutlinedIcon
                                                                    className="fontsz-30 mr-25"
                                                                    style={{ color: domain === CUSTOM_SIDEBAR(index) ? "#FBBC05" : grey[50] }}
                                                                />
                                                                : idGroupBR.includes(window.localStorage.getItem('group_id')) ?
                                                                    <VerticalSplitIcon className="fontsz-27 mr-25"
                                                                        style={{ color: domain === '/app/params' ? "#FBBC05" : grey[50] }} />
                                                                    :
                                                                    <PersonIcon
                                                                        className="fontsz-30"
                                                                        style={{ color: domain === CUSTOM_SIDEBAR(index) ? "#FBBC05" : grey[50] }}
                                                                    />
                                                        }
                                                    </>
                                                case +4:
                                                    return <>
                                                        {[ID_GROUPS.KG, ID_GROUPS.DOT].includes(window.localStorage.getItem('group_id')) &&
                                                            <PersonIcon
                                                                className="fontsz-30"
                                                                style={{ color: domain === CUSTOM_SIDEBAR(index) ? "#FBBC05" : grey[50] }}
                                                            />
                                                        }
                                                        {[ID_GROUPS.AC].includes(window.localStorage.getItem('group_id')) &&
                                                            <VolumeUpIcon
                                                                className="fontsz-30"
                                                                style={{ color: domain === CUSTOM_SIDEBAR(index) ? "#FBBC05" : grey[50] }}
                                                            />
                                                        }
                                                        {idGroupBR.includes(window.localStorage.getItem('group_id')) &&
                                                            <TopicIcon
                                                                className="fontsz-30"
                                                                style={{ color: domain === '/app/exploit' ? "#FBBC05" : grey[50] }}
                                                            />
                                                        }
                                                    </>
                                                case +5:
                                                    return <>
                                                        {idGroupBR.includes(window.localStorage.getItem('group_id')) &&
                                                            <StorageIcon
                                                                className="fontsz-30"
                                                                style={{ color: domain === '/app/group' ? "#FBBC05" : grey[50] }}
                                                            />
                                                        }
                                                    </>
                                                case +6:
                                                    return <>
                                                        {idGroupBR.includes(window.localStorage.getItem('group_id')) &&
                                                            <SaveAsIcon
                                                                className="fontsz-30"
                                                                style={{ color: domain === '/app/operate' ? "#FBBC05" : grey[50] }}
                                                            />
                                                        }
                                                    </>
                                                 case +7:
                                                    return <>
                                                        {idGroupBR.includes(window.localStorage.getItem('group_id')) &&
                                                            <DriveFileMoveIcon
                                                                className="fontsz-30"
                                                                style={{ color: domain === '/app/transfer' ? "#FBBC05" : grey[50] }}
                                                            />
                                                        }
                                                    </>
                                                case +8:
                                                    return <>
                                                        {idGroupBR.includes(window.localStorage.getItem('group_id')) &&
                                                            <PersonIcon
                                                                className="fontsz-30"
                                                                style={{ color: domain === '/app/user' ? "#FBBC05" : grey[50] }}
                                                            />
                                                        }
                                                    </>
                                                default:
                                                    break;
                                            }
                                        })()}
                                    </ListItemIcon>
                                    {![+2].includes(index) && text}
                                    {[ID_GROUPS.DOT, ID_GROUPS.KG, ID_GROUPS.AC, ID_GROUPS.SR, ID_GROUPS.DB, ID_GROUPS.XM, ID_GROUPS.SC, ID_GROUPS.KL, ID_GROUPS.CP].includes(window.localStorage.getItem('group_id')) && index === 2 && text}
                                </ListItemButton>
                            </Link>
                            {ID_GROUPS.AC !== window.localStorage.getItem('group_id') && ID_GROUPS.DOT !== window.localStorage.getItem('group_id') && ID_GROUPS.KG !== window.localStorage.getItem('group_id') &&
                                <Collapse in={index === +2 && this.state.open} timeout="auto" unmountOnExit>
                                    <List component="div" disablePadding>
                                        {Children.toArray(["Số liệu thực tế", "Báo cáo tháng",
                                            // "Tính toán nội suy"
                                        ].map((text, index) => {
                                            return (
                                                <Link
                                                    href={(() => {
                                                        switch (index) {
                                                            case +0:
                                                                return `${DOMAIN.MONITOR}/list`;
                                                            case +1:
                                                                return `${DOMAIN.MONITOR}/report`;
                                                            // case +2:
                                                            //     return `${DOMAIN.MONITOR}/compute`;
                                                            default:
                                                                return;
                                                        }
                                                    })()}
                                                    underline="none"
                                                >
                                                    <ListItemButton
                                                        sx={{ pl: 4 }}
                                                    >
                                                        <ListItemIcon sx={{ pl: 3 }}>
                                                            <FiberManualRecordIcon className="fontsz-8" style={{ color: grey[50] }} />
                                                        </ListItemIcon>
                                                        <ListItemText
                                                            primary={text}
                                                            style={{ color: grey[50] }}
                                                        />
                                                    </ListItemButton>
                                                </Link>
                                            )
                                        }))}
                                    </List>
                                </Collapse>
                            }
                        </>
                    )))}
                </List>
            </div >
        )
    };
    handleSubMenu = () => {
        this.setState({ open: !this.state.open });
    }

    handleChangeBoxGroup = (group_id, time) => {
        this.setState({ group_id: group_id });
        if (typeof time === "object") {
            this.setState({
                time: time
            })
        }
    }

    handleChangeBoxSelected = (box_id) => {
        this.setState({ boxSelected: box_id })
    }

    handleChangeMetricSelected = (metric) => {
        this.setState({ metricSelected: metric })
    }

    handleExportExcel = (toggle) => {
        this.setState({ exportExcel: toggle })
    }

    handleSearchRecords = (toggle) => {
        this.setState({ searchRecords: toggle })
    }

    componentDidMount() {
        const token = authService.getToken();
        if (!CHECK_EMPTY_STRING(token)) {
            this.setState({ auth: true });
            sharedService.listBox().then(
                res => {
                    const groups = res.data;
                    if (ID_GROUPS.DOT === BOXGROUP_ID) groups.push(BOX_DOT2)
                    this.setState({
                        groups: groups,
                    });
                }
            ).catch(err => console.log(err))
        }

        if (!authService.getUserInfo()) {
            authService.getMe().then(res => {
                const user = res.data?.user
                authService.setUserInfo(user)
                this.setState({
                    userName: user.full_name
                })
            })
        }

    }

    logOut() {
        authService.setToken({ id: "" });
        authService.setGroupId("");
        window.localStorage.clear();
        window.sessionStorage.clear();
        goTo("app/login");
    }
    handleDrawerToggle() {
        this.setState({
            mobileOpen: !this.state.mobileOpen
        });
    };

    handleSelectGroup(e) {
        const id = e.target.value
        window.localStorage.setItem("group_id", id)
        // window.location.href = "/app/map";
        setTimeout(() => {
            window.location.reload();
        }, 100);
    }

    render() {
        const { groups, time, group_id, auth, mobileOpen, boxSelected, exportExcel, metricSelected, searchRecords, userName } = this.state;
        const { domain } = this;
        const userGroups = authService?.getUserInfo()?.groups || []

        return (
            <div className="App">
                {auth ?
                    // window.localStorage.getItem('group_id') === 'KKKXW2TW' ?
                    //     <Alert 
                    //         variant="filled" 
                    //         severity="error"
                    //         action={
                    //             <Button color="inherit" size="small" onClick={() => this.logOut()}>
                    //               Đăng xuất
                    //             </Button>
                    //         }
                    //     >
                    //         Tài khoản của bạn đã bị vô hiệu hoá, vui lòng liên hệ với nhân sự chuyên trách thuộc Thuận Phong để được hỗ trợ!</Alert>
                    // :
                    <Box sx={{ display: 'flex' }}>
                        <CssBaseline />
                        <AppBar
                            position="fixed"
                            sx={{
                                width: { sm: `calc(100% - ${drawerWidth}px)` },
                                ml: { sm: `${drawerWidth}px` },
                            }}
                            style={{ backgroundColor: "white", boxShadow: "none", border: '1.5px solid #0000001f' }}
                        >
                            <Toolbar>
                                <Grid container className='align-center'>
                                    <Grid item sx={{ display: { xs: 1, sm: 'none' } }}>
                                        <IconButton
                                            color="success"
                                            edge="start"
                                            onClick={() => this.handleDrawerToggle()}
                                            sx={{ mr: 2, display: { sm: 'none' } }}
                                        >
                                            <MenuIcon />
                                        </IconButton>
                                    </Grid>
                                    <Grid item xs={8} md={10}
                                    // className="menu-app"
                                    >
                                        {[`${DOMAIN.MONITOR}/list`, DOMAIN.CHART].includes(domain) ?
                                            groups.length !== +0 &&
                                            <Grid sx={{ display: { xs: 'none', md: 'block' } }}>
                                                <MenuApp
                                                    searchRecords={searchRecords}
                                                    handleSearchRecords={this.handleSearchRecords}
                                                    groups={groups}
                                                    time={time}
                                                    groupId={group_id}
                                                    domain={domain}
                                                    parentCallBack={this.handleChangeBoxGroup}
                                                    boxSelected={boxSelected}
                                                    metricSelected={metricSelected}
                                                    handleChangeBoxSelected={this.handleChangeBoxSelected}
                                                    handleChangeMetricSelected={this.handleChangeMetricSelected}
                                                    handleExportExcel={this.handleExportExcel}
                                                />
                                            </Grid>
                                            :
                                            <>
                                                <Grid container
                                                    sx={{ display: { md: 'none' }, alignItems: 'center' }}
                                                    className="logo_responsive"
                                                >
                                                    <Grid xs={4} item>
                                                        <img src={logo} alt="logo" />
                                                    </Grid>
                                                    <Grid xs={8} item>
                                                        <Typography
                                                            sx={{
                                                                fontWeight: 700,
                                                                fontSize: 14,
                                                                color: 'red',
                                                            }}
                                                        >THUẬN PHONG</Typography>
                                                    </Grid>
                                                </Grid>
                                                <Grid container
                                                    sx={{ display: { xs: 'none', sm: 'none', md: 'block' }, alignItems: 'center' }}
                                                    className="logo_responsive"
                                                >
                                                    <Grid md={8} item>
                                                        <Typography
                                                            sx={{
                                                                fontWeight: 700,
                                                                fontSize: 14,
                                                                color: '#4385f4',
                                                            }}
                                                        >
                                                            <div className='flex'>
                                                                <div className='mr-50 flex align-center'><PersonIcon />{userName}</div>
                                                                {idGroupBR.includes(window.localStorage.getItem('group_id')) &&
                                                                    <div>
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 640 512"><path fill="currentColor" d="M480 48c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v48h-64V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v72h-64V24c0-13.3-10.7-24-24-24S64 10.7 64 24v72H48c-26.5 0-48 21.5-48 48v320c0 26.5 21.5 48 48 48h544c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48H480zm96 320v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16m-336 48h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16m-112-16c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zm432-144c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm-304-80v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16m-144-16c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm144 144c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zm-144 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16m304-48v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16M400 64c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zm16 112v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16" /></svg>
                                                                        <select className='selectGroup' onChange={(e) => this.handleSelectGroup(e)}>
                                                                            {groupBR.filter(g => userGroups.includes(g.id)).map(g => <option selected={window.localStorage.getItem('group_id') === g.id ? true : false} key={g.id} value={g.id}>{g.name}</option>)}
                                                                        </select>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            </>
                                        }
                                    </Grid>

                                    <Grid item xs={2} md={2} lg={2} sx={{
                                        textAlign: { xs: "center", md: "right" }
                                    }}>
                                        {idGroupBR.includes(window.localStorage.getItem('group_id')) ?
                                            <>
                                                <div
                                                    className={`backdropBR ${this.state.isOpenBR ? "showBR" : ""}`}
                                                    onClick={() => this.setState({ isOpenBR: false })}
                                                />
                                                <div className={`project-panel ${this.state.isOpenBR ? "openBR" : ""}`}>
                                                    <h4>Danh sách công trình</h4>
                                                    <ul>
                                                        {groupBR.filter(g => userGroups.includes(g.id)).map(g => (
                                                            <li key={g.id}>
                                                                <div onClick={() => this.handleSelectGroup({ target: { value: g.id } })}>{g.name}</div>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                                <Tooltip title="Chọn group">
                                                    <IconButton
                                                        color="success"
                                                        onClick={() => this.setState({ isOpenBR: true })}
                                                        sx={{ display: { xs: "inline-flex", md: "none" } }}
                                                    >
                                                        <label for=""><HomeIcon className="fontsz-30" /></label>
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title="Tải lại trang">
                                                    <IconButton
                                                        color="success"
                                                        onClick={() => window.location.reload()}
                                                        sx={{ display: { xs: "none", md: "inline-flex" } }}
                                                    >
                                                        <RefreshIcon className="fontsz-30 mr-10" />
                                                    </IconButton>
                                                </Tooltip>
                                            </>
                                            :
                                            <Tooltip title="Tải lại trang">
                                                <IconButton
                                                    color="success"
                                                    onClick={() => window.location.reload()}
                                                >
                                                    <RefreshIcon className="fontsz-30 mr-10" />
                                                </IconButton>
                                            </Tooltip>
                                        }
                                        <Tooltip title="Thoát">
                                            <IconButton
                                                color="success"
                                                onClick={this.logOut}
                                            >
                                                <LogoutIcon className="fontsz-30" />
                                            </IconButton>
                                        </Tooltip>
                                    </Grid>
                                </Grid>
                            </Toolbar>
                        </AppBar>
                        <Box
                            component="nav"
                            sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
                        >
                            <Drawer
                                container={this.container}
                                variant="temporary"
                                open={mobileOpen}
                                onClose={() => this.handleDrawerToggle()}
                                ModalProps={{
                                    keepMounted: true, // Better open performance on mobile.
                                }}
                                sx={{
                                    display: { xs: 'block', sm: 'none' },
                                    '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                                }}
                                PaperProps={{
                                    sx: {
                                        backgroundColor: "#4285F4",
                                        color: "white",
                                    }
                                }}
                            >
                                {this.drawer(this.domain)}
                            </Drawer>
                            <Drawer
                                variant="permanent"
                                sx={{
                                    display: { xs: 'none', sm: 'block' },
                                    '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                                }}
                                PaperProps={{
                                    sx: {
                                        backgroundColor: "#4285F4",
                                        color: "white",
                                    }
                                }}
                                open
                            >
                                {this.drawer(this.domain)}
                            </Drawer>
                        </Box>
                        <Box
                            component="main"
                            sx={{ mt: { xs: 4.85, md: 8.4 }, width: { xs: '100%', sm: `calc(100% - ${drawerWidth - 12}px)` } }}
                        >
                            <div className="container" >
                                <Switch>
                                    <Route exact path="/" render={() => <Redirect to="/app/dashboard" ></Redirect>} />
                                    <Route exact path="/app" render={() => <Redirect to="/app/dashboard" ></Redirect>} />
                                    <Route path="/app/dashboard" render={() => {
                                        if (idGroupBR.includes(localStorage.getItem('group_id'))) return <DashBoardBR boxs={groups} />
                                        else return <DashBoard />
                                    }} />
                                    {idGroupBR.includes(localStorage.getItem('group_id')) ?
                                        <Route path="/app/monitor/list" render={() => <MonitorBR boxs={groups} time={time} boxSelected={boxSelected} exportExcel={exportExcel} handleExportExcel={this.handleExportExcel} />} />
                                        :
                                        <Route path="/app/monitor" render={() => <Monitor handleSearchRecords={this.handleSearchRecords} searchRecords={searchRecords} exportExcel={exportExcel} handleExportExcel={this.handleExportExcel} groups={groups} groupId={group_id} time={time} boxSelected={boxSelected} />} />
                                    }
                                    <Route path="/app/group" render={() => <Group />} />
                                    <Route path="/app/zone" render={() => <Zone />} />
                                    <Route path="/app/help/audio" render={() => <Audio />} />
                                    <Route path="/app/help" render={() => <Help />} />
                                    <Route path="/app/user" render={() => <User />} />
                                    <Route path="/app/chart" render={() => <ChartComponent time={time} boxSelected={boxSelected} metricSelected={metricSelected} boxs={groups} groupId={group_id} />} />
                                    <Route path="/app/map" render={() => <Map boxs={groups} groupId={group_id} />} />
                                    <Route path="/app/params" render={() => <ParamsComponent />} />
                                    <Route path="/app/exploit" render={() => <Exploit />} />
                                    <Route path="/app/transfer" render={() => <Exploit />} />
                                    <Route path="/app/operate" render={() => <Exploit />} />
                                </Switch>
                            </div>
                        </Box>
                    </Box>
                    : <Login />}
            </div>
        );
    }
}

export default withRouter(App);